import {Component, OnInit} from '@angular/core';
import {LoanApplicationService} from '../../loan-application.service';
import {ProvinceSelectService} from 'src/app/@modules/province-select/province-select.service';
import {CitySelectService} from 'src/app/@modules/city-select/city-select.service';

@Component({
  selector: 'bb-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {
  personal_info = this.loan.form.get('personal_info');
  constructor(public loan: LoanApplicationService,
              public province: ProvinceSelectService,
              public city: CitySelectService) {}

  ngOnInit() {}
}
